import { useContractCall } from "@usedapp/core";

import { ethers } from "ethers";
import { ABI } from "../abi";

const useIsClaimed = (
  account: string | undefined | null
): boolean | undefined => {
  const call = {
    abi: new ethers.utils.Interface(ABI),
    address: process.env.REACT_APP_NFT_ADDRESS ?? "",
    method: "isClaimed",
  };

  const [isClaimed] = useContractCall({ ...call, args: [account] }) ?? [
    undefined,
  ];

  return isClaimed;
};

export default useIsClaimed;
